import type { EmbarcacaoClasseField } from "@/modules/embarcacoes";
import { formatDetailDate } from "../../../detail-format/detail-format";
import type { DetailFieldDefinition } from "../../../detail-format/detail-fields";

export const CLASSE_ID = "classe";
export const CLASSE_TITLE = "Classe";
export const CLASSE_TEST_ID = "embarcacao-classe";
export const CLASSE_LOADING_MESSAGE = "Carregando a Classe da embarcação...";

/** Padrão global de estado vazio do Hub para a seção sem informações. */
export const CLASSE_EMPTY_STATE = {
  title: "Nenhuma informação de Classe disponível",
  description:
    "Assim que houver informações de classe para esta embarcação, elas aparecerão nesta seção.",
};

/**
 * Os 19 campos da seção, na ordem e nas colunas do protótipo (AC2). O grid os
 * distribui em duas colunas, preenchendo a linha da esquerda para a direita.
 *
 * O protótipo isola cada janela de vistoria: Última Especial e Última
 * Intermediária fecham a sua janela sozinhas na coluna da esquerda, e o mesmo
 * vale para Bottom Survey (To). Por isso Intermediária (From), Última Bottom
 * Survey e Thruster (To) abrem linha; nos demais pontos o preenchimento
 * corrido já reproduz as colunas desenhadas, par a par.
 *
 * As datas recebem apenas o formato de leitura do Hub — nenhum valor é
 * calculado ou derivado (AC3).
 */
export const CLASSE_FIELDS: readonly DetailFieldDefinition<EmbarcacaoClasseField>[] = [
  { key: "notacaoClasse", label: "Notação de Classe" },
  {
    key: "validadeNotacaoClasse",
    label: "Data de Validade da Notação de Classe",
    format: formatDetailDate,
  },
  { key: "classificadoraAtual", label: "Classificadora Atual" },
  { key: "ultimoReportClasse", label: "Último report de classe", format: formatDetailDate },
  { key: "anualFrom", label: "Anual (From)", format: formatDetailDate },
  { key: "anualTo", label: "Anual (To)", format: formatDetailDate },
  { key: "especialFrom", label: "Especial (From)", format: formatDetailDate },
  { key: "especialTo", label: "Especial (To)", format: formatDetailDate },
  { key: "ultimaEspecial", label: "Última Especial", format: formatDetailDate },
  {
    key: "intermediariaFrom",
    label: "Intermediária (From)",
    format: formatDetailDate,
    startsRow: true,
  },
  { key: "intermediariaTo", label: "Intermediária (To)", format: formatDetailDate },
  { key: "ultimaIntermediaria", label: "Última Intermediária", format: formatDetailDate },
  {
    key: "ultimaBottom",
    label: "Última Bottom Survey",
    format: formatDetailDate,
    startsRow: true,
  },
  {
    key: "condicaoUltimaBottom",
    label: "Condição da Última Bottom Survey",
    format: formatDetailDate,
  },
  { key: "bottomTo", label: "Bottom Survey (To)", format: formatDetailDate },
  { key: "thrusterTo", label: "Thruster (To)", format: formatDetailDate, startsRow: true },
  { key: "propulsaoTo", label: "Propulsão (To)", format: formatDetailDate },
  // O AC2 e a tela de edição do protótipo pedem o último FMEA antes do seu
  // vencimento; só a tela de visualização os desenha na ordem inversa.
  { key: "ultimoFmea", label: "Último FMEA", format: formatDetailDate },
  { key: "vencimentoFmea", label: "Vencimento FMEA", format: formatDetailDate },
];
